import { ButtonBlockType, ButtonComponent } from './button-block'
import { AccordianBlockType, AccordianComponent } from './accordian-block'
import { ColumnLayoutBlockType, ColumnLayoutComponent } from './column-layout-block'
import { ContentCarouselBlockType, ContentCarouselComponent } from './content-carousel-block'
import { FaqsBlockType, FaqsComponent } from './faqs-block'
import { FeaturedContentBlockType, FeaturedContentComponent } from './featured-content-block'
import {
  FeaturedContentCarouselBlockType,
  FeaturedContentCarouselComponent,
} from './featured-content-carousel-block'
import { HeadingBlockType, HeadingComponent } from './heading-block'
import { HtmlBlockType, HtmlComponent } from './html-block'
import { ImageBlockType, ImageComponent } from './image-block'
import { JumpToLinksBlockType, JumpToLinksComponent } from './jump-to-links-block'
import { ReferFriendBlockType, ReferFriendContainer } from './refer-friend-block'
import { RichTextBlockType, RichTextComponent } from './rich-text-block'
import { SearchBlockType, SearchComponent } from 'app/features/offer/blocks'
import { ShareLinkBlockType, ShareLinkContainer } from './share-link-block'
import { SpacerBlockType, SpacerComponent } from './spacer-block'
import { VideoBlockType, VideoComponent } from './video-block'

type ExcludedPlatforms = {
  web?: boolean
  ios?: boolean
  android?: boolean
}

export const mapExcludedPlatforms = (excludedPlatforms: ExcludedPlatforms) => {
  return Object.keys(excludedPlatforms)
    .map((p) => (excludedPlatforms[p] ? p : null))
    .filter(Boolean)
}

export type BlockToComponentMap = {
  [key: string]: { Component: React.ComponentType<any>; canRender?: (block: any) => boolean }
}

export const getSharedBlockMappings = (): BlockToComponentMap => ({
  [AccordianBlockType]: { Component: AccordianComponent },
  [ButtonBlockType]: { Component: ButtonComponent },
  [ColumnLayoutBlockType]: { Component: ColumnLayoutComponent },
  [ContentCarouselBlockType]: { Component: ContentCarouselComponent },
  [FaqsBlockType]: { Component: FaqsComponent },
  [FeaturedContentBlockType]: { Component: FeaturedContentComponent },
  [FeaturedContentCarouselBlockType]: { Component: FeaturedContentCarouselComponent },
  [HeadingBlockType]: { Component: HeadingComponent },
  [HtmlBlockType]: { Component: HtmlComponent },
  [ImageBlockType]: { Component: ImageComponent },
  [JumpToLinksBlockType]: { Component: JumpToLinksComponent },
  [ReferFriendBlockType]: { Component: ReferFriendContainer },
  [RichTextBlockType]: { Component: RichTextComponent },
  [SearchBlockType]: { Component: SearchComponent },
  [ShareLinkBlockType]: { Component: ShareLinkContainer },
  [SpacerBlockType]: { Component: SpacerComponent },
  [VideoBlockType]: { Component: VideoComponent },
})
